/*-- 处理router的方法 --*/
import router_menus from './router_list'
import {is_prod} from '@/libs/util.js'
const strReducer = (total,path,component) => {
    total.push({
        path,
        component,
    })
}
const objReducer = (total,item,component) => {
    const { path,noChkout=false,justDev } = item
    if(justDev&&is_prod) {
        return 
    }
    total.push({
        path,
        noChkout,
        component
    })
}

const router_list = router_menus.reduce((total,router_component)=>{
    const { router_info,component } = router_component
    switch (Object.prototype.toString.call(router_info)) {
        case "[object String]":
        strReducer(total,router_info,component)
            break;
        case "[object Array]":
            router_info.forEach(router_info_child => {
            if(typeof router_info_child === 'string') {
                strReducer(total,router_info_child,component)
            } else {
                objReducer(total,router_info_child,component)
            }
        });
            break
        case "[object Object]":
        objReducer(total,router_info,component)
        break
        default:
            break;
    }
    return total
},[])
export const path_arr = router_list.map(item=>item.path)
export const path_arr_vue = router_list
